(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* O <span> do markup é reaproveitado e só lhe trocamos o conteúdo a meio do fade. Reconstruí-lo
     a cada volta obrigava a esperar um frame para a transição pegar num nó acabado de inserir —
     corrida frágil, que falhava de vez em quando e deixava a barra vazia. */
  const ANNOUNCEMENT_INTERVAL = 5000;
  const ANNOUNCEMENT_FADE = 250;
  let announcementBarApi = null;

  function initAnnouncementBar() {
    if (announcementBarApi) announcementBarApi.destroy();

    const bar = document.querySelector('.announcement-bar');
    const track = bar && bar.querySelector('.announcement-bar__track');
    const message = track && track.querySelector('span');
    if (!message) return;

    let messages = [];
    try {
      messages = JSON.parse(bar.getAttribute('data-messages') || '[]');
    } catch (e) {
      console.error('[announcement-bar] não foi possível ler as mensagens', e);
    }
    if (messages.length === 0) return;

    let index = 0;
    let rotationId = null;
    let swapId = null;

    function stopAnnouncementRotation() {
      clearInterval(rotationId);
      clearTimeout(swapId);
      rotationId = null;
      swapId = null;
      message.classList.remove('is-hidden');
    }

    /* Com mais de uma mensagem, trocam de 5 em 5 segundos, em todos os ecrãs, como no tema antigo. */
    if (messages.length > 1) {
      rotationId = setInterval(() => {
        message.classList.add('is-hidden');
        swapId = setTimeout(() => {
          index = (index + 1) % messages.length;
          message.innerHTML = messages[index];
          message.classList.remove('is-hidden');
        }, ANNOUNCEMENT_FADE);
      }, ANNOUNCEMENT_INTERVAL);
    }

    announcementBarApi = {
      destroy() {
        stopAnnouncementRotation();
        announcementBarApi = null;
      }
    };
  }

  initAnnouncementBar();

  /* O bundle da Shopify corre uma vez; no editor a section é substituída sem o reexecutar. */
  document.addEventListener('shopify:section:load', e => {
    if (e.target.querySelector && e.target.querySelector('.announcement-bar')) initAnnouncementBar();
  });

  document.addEventListener('shopify:section:unload', e => {
    if (announcementBarApi && e.target.querySelector && e.target.querySelector('.announcement-bar')) {
      announcementBarApi.destroy();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* O formulário da página é um theme.CartForm, como o do drawer: o − / +, o "Move to favourites" e
     as linhas refeitas com o cart.ajax.liquid depois de cada mudança. */
  let cartPageForm = null;

  function initCartPage() {
    if (cartPageForm) cartPageForm.destroy();
    const form = document.getElementById('CartPageForm');
    cartPageForm = form ? new window.theme.CartForm(form) : null;
  }

  /* O JS das sections corre antes do dos snippets, e o CartForm vive num snippet (cart-drawer): o
     primeiro init espera que os dois tenham corrido. */
  document.addEventListener('DOMContentLoaded', initCartPage);

  /* Um artigo adicionado nesta página (o "+" de um card da pesquisa) entra nas linhas. */
  document.addEventListener('ajaxProduct:added', () => {
    if (cartPageForm) cartPageForm.buildCart();
  });

  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('#CartPageForm')) initCartPage();
  });

  document.addEventListener('shopify:section:unload', event => {
    if (!cartPageForm || !event.target.querySelector('#CartPageForm')) return;
    cartPageForm.destroy();
    cartPageForm = null;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
/* O logo do PRR só aparece em Portugal, à esquerda do ©.
   O init corre no load e outra vez a cada shopify:section:load, porque o editor substitui o
   markup da section e o PRR volta a vir hidden. Só a marcação é repetível: o país fica em
   cache e o comportamento do launcher prende-se uma única vez, senão cada edição no editor
   acrescentava mais um <style> e mais um par de listeners de scroll. */
let footerPRRIsPT = null;
let footerPRRLauncherBound = false;

const footerPRRMark = function() {
  const prr = document.getElementById('footerPRR');
  if (footerPRRIsPT && prr) prr.hidden = false;
};

const footerPRRInit = function() {
  if (footerPRRIsPT !== null) { footerPRRMark(); return; }

  fetch('/browsing_context_suggestions.json')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      const countryCode = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      footerPRRIsPT = countryCode === 'PT';
      footerPRRMark();

      if (footerPRRIsPT && !footerPRRLauncherBound) {
        footerPRRLauncherBound = true;

        const launcherStyle = document.createElement('style');
        launcherStyle.innerHTML = 'iframe#launcher { transition: bottom 0.25s ease; }';
        document.head.appendChild(launcherStyle);

        const applyFooterPRRLauncherBehavior = function() {
          const launcher = document.querySelector('iframe#launcher');
          if (!launcher) return false;

          const FOOTER_PRR_THRESHOLD = 2;
          const setLauncherBottom = function(px) { launcher.style.setProperty('bottom', px, 'important'); };

          const isAtPageBottom = function() {
            const doc = document.documentElement;
            return (window.scrollY || doc.scrollTop || 0) + (window.innerHeight || doc.clientHeight || 0) >= (doc.scrollHeight || document.body.scrollHeight || 0) - FOOTER_PRR_THRESHOLD;
          };

          const updateFooterPRRLauncherOffset = function() {
            setLauncherBottom(window.innerWidth < 769 ? '0px' : (isAtPageBottom() ? '50px' : '0px'));
          };

          let footerPRRTicking = false;
          const onFooterPRRScrollOrResize = function() {
            if (!footerPRRTicking) {
              requestAnimationFrame(function() {
                updateFooterPRRLauncherOffset();
                footerPRRTicking = false;
              });
              footerPRRTicking = true;
            }
          };

          window.addEventListener('scroll', onFooterPRRScrollOrResize, { passive: true });
          window.addEventListener('resize', onFooterPRRScrollOrResize);
          updateFooterPRRLauncherOffset();
          return true;
        };

        if (!applyFooterPRRLauncherBehavior()) {
          const footerPRRObserver = new MutationObserver(function() {
            if (applyFooterPRRLauncherBehavior()) {
              footerPRRObserver.disconnect();
              clearTimeout(footerPRRObserverTimeout);
            }
          });
          footerPRRObserver.observe(document.documentElement || document.body, { childList: true, subtree: true });
          const footerPRRObserverTimeout = setTimeout(function() { footerPRRObserver.disconnect(); }, 15000);
        }
      }
    })
    .catch(function(err) {
      footerPRRIsPT = false;
      console.error('Footer PRR error:', err);
    });
};

/* O footer avisa quando entra e sai do ecrã: as barras pretas do fundo (.bottom-bar, no
   critical.css) saem quando ele aparece. O estado fica em window.theme.footerVisible, para quem
   começa a ouvir depois do aviso. */
let footerVisibilityObserver = null;

const footerSetVisible = function(visible) {
  window.theme = window.theme || {};
  window.theme.footerVisible = visible;
  document.dispatchEvent(new CustomEvent('footer:visibility'));
};

const footerWatchVisibility = function() {
  if (footerVisibilityObserver) footerVisibilityObserver.disconnect();
  const footer = document.querySelector('.site-footer');
  if (!footer) return;
  footerVisibilityObserver = new IntersectionObserver(function(entries) {
    footerSetVisible(entries[entries.length - 1].isIntersecting);
  });
  footerVisibilityObserver.observe(footer);
};

const footerInit = function() {
  footerPRRInit();
  footerWatchVisibility();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', footerInit);
} else {
  footerInit();
}

document.addEventListener('shopify:section:load', function(e) {
  if (e.target.querySelector('.site-footer')) footerInit();
});

/* Sem footer não há quem avise: as barras deixam de estar escondidas por ele. */
document.addEventListener('shopify:section:unload', function(e) {
  if (!footerVisibilityObserver || !e.target.querySelector('.site-footer')) return;
  footerVisibilityObserver.disconnect();
  footerVisibilityObserver = null;
  footerSetVisible(false);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── Header: máquina de estados de scroll ───────────────────────────────────────
     base     (no topo)      sem classes — nav transparente com exclusion, sobre o conteúdo
     scrolled (fora do topo) js-header-scrolled — a announcement sai e a nav encosta ao topo
     solid    (a subir)      js-header-solid — nav branca opaca com o conteúdo a preto

     A announcement bar só se vê no topo: o js-header-scrolled fica posto nos dois sentidos e
     é o js-header-solid, sozinho, que distingue subir de descer.

     As classes vão para o <html> (como o .js-drawer-open) e cada componente escreve as suas
     próprias regras. O handler de scroll não mede nem escreve estilos: lê o scrollY e, dentro
     de um rAF, troca classes só quando o estado muda. */
  const HEADER_SCROLL_DEADZONE = 4;
  let headerScrollApi = null;

  function initHeaderScroll() {
    if (headerScrollApi) headerScrollApi.destroy();

    const wrapper = document.querySelector('.header-wrapper');
    if (!wrapper) return;

    const root = document.documentElement;
    const announcement = document.querySelector('.announcement-bar');
    let announcementHeight = announcement ? announcement.offsetHeight : 0;
    let lastScrollY = Math.max(0, window.scrollY);
    let ticking = false;
    let frozen = false;

    function applyHeaderState() {
      ticking = false;
      if (frozen) return;

      const y = Math.max(0, window.scrollY);
      const delta = y - lastScrollY;

      if (y <= announcementHeight) {
        root.classList.remove('js-header-scrolled', 'js-header-solid');
      } else if (delta > HEADER_SCROLL_DEADZONE) {
        root.classList.add('js-header-scrolled');
        root.classList.remove('js-header-solid');
      } else if (delta < -HEADER_SCROLL_DEADZONE) {
        root.classList.add('js-header-scrolled');
        root.classList.add('js-header-solid');
      } else {
        return; /* dentro da deadzone: não mexe e guarda a referência, para o movimento somar */
      }

      lastScrollY = y;
    }

    function onHeaderScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(applyHeaderState);
    }

    /* ── Megamenus: movidos para o body para escaparem ao grupo de mix-blend-mode do header.
       Sem isto o painel preto seria invertido pelo exclusion. O top e o deslocamento são CSS. */
    const movedMegamenus = [];

    document.querySelectorAll('.header-nav__megamenu').forEach(menu => {
      const navItem = menu.closest('.header-nav__item--megamenu');
      if (!navItem) return;

      movedMegamenus.push({ menu: menu, navItem: navItem });
      document.body.appendChild(menu);

      let closeTimer;

      function openMenu() {
        clearTimeout(closeTimer);
        menu.classList.add('header-nav__megamenu--open');
        root.classList.add('js-header-megamenu');
      }

      function closeMenu() {
        closeTimer = setTimeout(() => {
          menu.classList.remove('header-nav__megamenu--open');
          root.classList.remove('js-header-megamenu');
        }, 100);
      }

      navItem.addEventListener('mouseenter', openMenu);
      navItem.addEventListener('mouseleave', closeMenu);
      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);

      navItem.addEventListener('focusin', openMenu);
      navItem.addEventListener('focusout', e => {
        if (!navItem.contains(e.relatedTarget) && !menu.contains(e.relatedTarget)) closeMenu();
      });
      menu.addEventListener('focusout', e => {
        if (!menu.contains(e.relatedTarget) && !navItem.contains(e.relatedTarget)) closeMenu();
      });
    });

    /* ── Clone do link de sale: também fora do grupo de blend, senão o vermelho da marca sai
       invertido por cima da foto. O original fica transparente e este fica por cima.
       O vertical é CSS (mesma variável --header-shift do header); o JS só trata do horizontal. */
    const saleLink = document.querySelector('.header-nav__item--sale > .header-nav__link');
    let saleClone = null;

    function syncHeaderSaleClone() {
      if (!saleClone) return;
      const linkRect = saleLink.getBoundingClientRect();
      const wrapperRect = wrapper.getBoundingClientRect();
      const wrapperTop = parseFloat(getComputedStyle(wrapper).top) || 0;

      /* A diferença entre os dois rects cancela o transform do estado, portanto o valor
         está certo mesmo a meio da transição. */
      saleClone.style.top = (wrapperTop + (linkRect.top - wrapperRect.top)) + 'px';
      saleClone.style.left = linkRect.left + 'px';
      saleClone.style.width = linkRect.width + 'px';
      saleClone.style.height = linkRect.height + 'px';
      saleClone.style.display = linkRect.width > 0 ? 'flex' : 'none';
    }

    if (saleLink) {
      saleLink.style.color = 'transparent';

      saleClone = document.createElement('a');
      saleClone.href = saleLink.href;
      saleClone.className = 'header-sale-clone';
      saleClone.setAttribute('aria-hidden', 'true');
      saleClone.textContent = saleLink.textContent.trim();
      document.body.appendChild(saleClone);

      syncHeaderSaleClone();
      if (document.fonts) document.fonts.ready.then(syncHeaderSaleClone);
    }

    function onHeaderResize() {
      announcementHeight = announcement ? announcement.offsetHeight : 0;
      syncHeaderSaleClone();
      applyHeaderState();
    }

    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    window.addEventListener('resize', onHeaderResize);
    applyHeaderState();

    headerScrollApi = {
      destroy() {
        window.removeEventListener('scroll', onHeaderScroll);
        window.removeEventListener('resize', onHeaderResize);
        /* Os megamenus voltam para o nav item de onde saíram, em vez de serem apagados: se a
           section for mesmo substituída, vão com o DOM antigo; se não for, não se perde nada. */
        movedMegamenus.forEach(entry => {
          entry.menu.classList.remove('header-nav__megamenu--open');
          entry.navItem.appendChild(entry.menu);
        });
        if (saleClone) saleClone.remove();
        root.classList.remove('js-header-scrolled', 'js-header-solid', 'js-header-megamenu');
        headerScrollApi = null;
      },
      /* Theme editor: com a section seleccionada, o merchant tem de ver o que está a editar. */
      freeze() {
        frozen = true;
        root.classList.remove('js-header-scrolled', 'js-header-solid');
      },
      unfreeze() {
        frozen = false;
        lastScrollY = Math.max(0, window.scrollY);
        applyHeaderState();
      }
    };
  }

  initHeaderScroll();

  /* ── Ciclo de vida no theme editor ──────────────────────────────────────────────
     Este bloco corre uma vez, no load; a Shopify substitui o HTML da section sem o voltar a
     executar. Sem isto, editar o header deixava a máquina de estados presa a nós que já não
     existem e ia acumulando megamenus e clones órfãos no body a cada edição. */
  function isHeaderScrollSection(target) {
    return !!(target && target.querySelector &&
      (target.querySelector('.header-wrapper') || target.querySelector('.announcement-bar')));
  }

  document.addEventListener('shopify:section:load', e => {
    if (isHeaderScrollSection(e.target)) initHeaderScroll();
  });

  document.addEventListener('shopify:section:unload', e => {
    if (!isHeaderScrollSection(e.target)) return;
    if (headerScrollApi) headerScrollApi.destroy();
    /* Apagar a announcement bar não apaga o header: é preciso reconstruir a máquina com a
       nova altura. O rAF espera que a section saia mesmo do DOM; se o que saiu foi o header,
       o initHeaderScroll não encontra o wrapper e desiste sozinho. */
    requestAnimationFrame(() => initHeaderScroll());
  });

  document.addEventListener('shopify:section:select', e => {
    if (headerScrollApi && isHeaderScrollSection(e.target)) headerScrollApi.freeze();
  });

  document.addEventListener('shopify:section:deselect', e => {
    if (headerScrollApi && isHeaderScrollSection(e.target)) headerScrollApi.unfreeze();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["loyalty"] && !Shopify.designMode) return;
  try {
    
  /* O Minga Club: os separadores do visitante, a barra do membro, o tier e o que a LoyaltyLion
     desenha depois de a página abrir (os popups, os pontos com espaço nos milhares). A LoyaltyLion
     não avisa quando acaba de desenhar: um MutationObserver na página vai vendo o que chega. */

  let loyaltyApi = null;

  // "1,000" passa a "1 000" (com um espaço que não parte a linha), como no Figma.
  function formatLoyaltyThousands(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      const formatted = node.nodeValue.replace(/(\d),(?=\d{3}(?!\d))/g, '$1 ');
      if (formatted !== node.nodeValue) node.nodeValue = formatted;
    }
  }

  function loyaltyNumber(element) {
    return element ? parseInt(element.textContent.replace(/[^0-9]/g, ''), 10) : NaN;
  }

  /* ── O separador do visitante ── */

  function selectLoyaltyTab(tab) {
    const nav = tab.closest('[data-loyalty-nav]');
    const root = tab.closest('[data-loyalty]');
    nav.querySelectorAll('[data-loyalty-tab]').forEach(other => {
      const selected = other === tab;
      other.setAttribute('aria-selected', String(selected));
      other.tabIndex = selected ? 0 : -1;
      const panel = root.querySelector('#' + other.getAttribute('aria-controls'));
      if (panel) panel.hidden = !selected;
    });

    // Com a barra presa por baixo do header, o separador novo começa à vista, logo abaixo dela.
    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    if (nav.getBoundingClientRect().top <= headerHeight + 1) {
      root.querySelector('#' + tab.getAttribute('aria-controls'))?.scrollIntoView({ block: 'start' });
    }
  }

  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-loyalty-tab]');
    if (tab) selectLoyaltyTab(tab);
  });

  // As setas e o Home / End passam de separador, como os do size guide.
  document.addEventListener('keydown', event => {
    const tab = event.target.closest?.('[data-loyalty-tab]');
    if (!tab) return;
    const tabs = [...tab.closest('[data-loyalty-nav]').querySelectorAll('[data-loyalty-tab]')];
    const index = tabs.indexOf(tab);
    const next = {
      ArrowRight: tabs[(index + 1) % tabs.length],
      ArrowLeft: tabs[(index - 1 + tabs.length) % tabs.length],
      Home: tabs[0],
      End: tabs[tabs.length - 1]
    }[event.key];
    if (!next) return;
    event.preventDefault();
    next.focus();
    selectLoyaltyTab(next);
  });

  /* ── O tier do membro ── */

  // A palavra fica com as letras encostadas ao canto do vídeo: cada letra começa a uma distância
  // diferente da sua caixa ("inside" afasta-se mais do que "floor"), por isso mede-se a palavra.
  function alignLoyaltyTierName(heading) {
    const context = document.createElement('canvas').getContext('2d');
    if (!context) return;
    const style = getComputedStyle(heading);
    const size = 100;
    context.font = `${style.fontWeight} ${size}px ${style.fontFamily}`;
    const metrics = context.measureText(heading.textContent);
    if (!metrics.fontBoundingBoxAscent) return;
    const ascent = metrics.fontBoundingBoxAscent / size;
    const descent = metrics.fontBoundingBoxDescent / size;
    const baselineFromBottom = descent - (ascent + descent - 1) / 2;
    heading.style.setProperty('--loyalty-tier-ink-left', `${(metrics.actualBoundingBoxLeft / size).toFixed(4)}em`);
    heading.style.setProperty('--loyalty-tier-ink-bottom', `${(-baselineFromBottom).toFixed(4)}em`);
  }

  // O nome do tier e o vídeo dele. Sem nome ao fim de 3 s (a LoyaltyLion em baixo), fica o vídeo
  // do primeiro tier.
  function showLoyaltyTier(root, tierName) {
    const heading = root.querySelector('[data-loyalty-tier-name]');
    const media = root.querySelector('[data-loyalty-hero-media]');
    const key = (tierName || '').trim().toLowerCase();
    if (heading && key) {
      heading.textContent = key;
      alignLoyaltyTierName(heading);
    }
    if (media && !media.childElementCount) {
      const template = (key && root.parentElement.querySelector(`[data-loyalty-tier-video="${CSS.escape(key)}"]`))
        || root.parentElement.querySelector('[data-loyalty-tier-video]');
      if (template) media.append(template.content.cloneNode(true));
    }
  }

  // "You're N points away from next tier.", com os pontos e o limite do tier seguinte que a
  // LoyaltyLion desenha.
  function updateLoyaltyTierAway(root) {
    const away = root.querySelector('[data-loyalty-tier-away]');
    const upcoming = root.querySelector('.lion-tier-progress__bar-section--upcoming');
    if (!away || !upcoming) return;
    const texts = window.theme.loyalty;
    const points = loyaltyNumber(root.querySelector('[data-lion-points="approved"]'));
    const bound = loyaltyNumber(upcoming.querySelector('.lion-tier-progress__bar-section__tier-bound'));
    const name = upcoming.querySelector('.lion-tier-progress__bar-section__tier-name')?.textContent.trim();
    if (isNaN(points) || isNaN(bound)) return;
    const missing = bound - points;
    away.textContent = missing > 0
      ? texts.tierAway.replace('[points]', String(missing).replace(/\B(?=(\d{3})+(?!\d))/g, ' '))
      : (name ? texts.tierReached.replace('[tier]', name) : texts.tierReachedNext);
  }

  /* ── O que a LoyaltyLion desenha na página ── */

  // As recompensas de produto trazem a fotografia da LoyaltyLion, e não a do editor: o card da
  // mesma recompensa no "Your rewards" leva-a também.
  function copyLoyaltyClaimedArt(root) {
    root.querySelectorAll('.lion-claimed-reward-item[data-reward-id]').forEach(claimed => {
      const icon = claimed.querySelector('.lion-claimed-reward-item__icon');
      if (!icon || icon.style.backgroundImage) return;
      const image = root.querySelector(`.lion-reward-item[data-reward-id="${claimed.dataset.rewardId}"] img[src]`);
      if (image) icon.style.backgroundImage = `url("${image.src}")`;
    });
  }

  function onLoyaltyRender(root, state) {
    formatLoyaltyThousands(root);
    copyLoyaltyClaimedArt(root);

    const historyHeaders = root.querySelectorAll('.lion-history-table th');
    if (historyHeaders.length >= 5) historyHeaders[2].textContent = window.theme.loyalty.historyType;

    if (root.dataset.loyalty === 'member') {
      updateLoyaltyTierAway(root);
      if (!state.tierShown) {
        const current = root.querySelector('.lion-tier-progress__bar-section--current .lion-tier-progress__bar-section__tier-name');
        if (current && current.textContent.trim()) {
          state.tierShown = true;
          showLoyaltyTier(root, current.textContent);
        }
      }
    }
  }

  /* ── A barra do membro: o sublinhado segue a secção à vista ── */

  function watchLoyaltySections(root) {
    const links = [...root.querySelectorAll('[data-loyalty-jump]')];
    if (!links.length) return null;
    const nav = root.querySelector('[data-loyalty-nav]');

    const setCurrent = id => links.forEach(link => {
      if (link.dataset.loyaltyJump === id) link.setAttribute('aria-current', 'true');
      else link.removeAttribute('aria-current');
    });

    // Uma linha de 1px onde os saltos param (30px abaixo da barra presa): a secção que a atravessa
    // é a que está à vista.
    const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    const line = headerHeight + nav.offsetHeight + 31;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) setCurrent(entry.target.dataset.loyaltyPart);
      });
    }, { rootMargin: `-${line}px 0px -${Math.max(window.innerHeight - line - 1, 0)}px 0px` });
    root.querySelectorAll('[data-loyalty-parts] > [data-loyalty-part]').forEach(part => observer.observe(part));

    const onClick = event => {
      const link = event.target.closest('[data-loyalty-jump]');
      if (link && root.contains(link)) setCurrent(link.dataset.loyaltyJump);
    };
    root.addEventListener('click', onClick);

    return () => {
      observer.disconnect();
      root.removeEventListener('click', onClick);
    };
  }

  function initLoyalty() {
    if (loyaltyApi) loyaltyApi.destroy();
    const root = document.querySelector('[data-loyalty]');
    if (!root) return;

    // No visitante, se nenhum painel ficou à vista, abre o primeiro separador.
    const tabs = root.querySelectorAll('[data-loyalty-tab]');
    if (tabs.length && !root.querySelector('[data-loyalty-parts] > [data-loyalty-part]:not([hidden])')) {
      selectLoyaltyTab(tabs[0]);
    }

    const state = { tierShown: false };
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        observer.disconnect();
        onLoyaltyRender(root, state);
        observer.observe(root, { childList: true, subtree: true, characterData: true });
      });
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    onLoyaltyRender(root, state);

    const tierTimer = root.dataset.loyalty === 'member'
      ? setTimeout(() => { if (!state.tierShown) { state.tierShown = true; showLoyaltyTier(root, ''); } }, 3000)
      : null;

    const stopSections = watchLoyaltySections(root);

    loyaltyApi = {
      destroy() {
        observer.disconnect();
        clearTimeout(tierTimer);
        if (stopSections) stopSections();
        loyaltyApi = null;
      }
    };
  }

  /* ── Os popups da LoyaltyLion ── */

  // Os popups abrem fora da página, num #loyaltylion no fim do body. Depois do toque num card,
  // vigia-se o documento até o popup aparecer (ou desistir), e só então.
  const loyaltyModalSelector = '.lion-modal-and-screen';

  function describeLoyaltyRule(card) {
    if (!card) return null;
    return {
      id: card.getAttribute('data-rule-id'),
      title: card.querySelector('.lion-rule-item__title')?.textContent.trim() || ''
    };
  }

  function loyaltyRewardArt(rewardId) {
    const card = document.querySelector(`.lion-reward-item[data-reward-id="${rewardId}"]`);
    if (!card) return null;
    const image = card.querySelector('img[src]');
    if (image) return `url("${image.src}")`;
    const icon = card.querySelector('.lion-reward-item__icon');
    const background = icon && getComputedStyle(icon).backgroundImage;
    return background && background !== 'none' ? background : null;
  }

  // Os termos da recompensa (a descrição dela na LoyaltyLion) não vêm no popup nem numa API: lêem-se
  // dos dados que o card da recompensa guarda. Se a LoyaltyLion mudar, deixam de aparecer, e a
  // consola avisa (warnLoyaltyModalShape).
  function loyaltyRewardData(rewardId) {
    const card = document.querySelector(`.lion-reward-item[data-reward-id="${rewardId}"]`);
    const key = card && Object.keys(card).find(name => name.startsWith('__reactFiber$'));
    if (!key) return null;
    const stack = [card[key].child];
    while (stack.length) {
      const fiber = stack.pop();
      if (!fiber) continue;
      const reward = fiber.memoizedProps && fiber.memoizedProps.reward;
      if (reward && String(reward.id) === String(rewardId)) return reward;
      stack.push(fiber.sibling, fiber.child);
    }
    return null;
  }

  function addLoyaltyRewardTerms(wrapper, rewardId) {
    const box = wrapper.querySelector('.lion-redeem-reward-modal__confirm-box');
    if (!box || box.querySelector('.loyalty-reward-terms')) return;
    const reward = loyaltyRewardData(rewardId);
    if (!reward) {
      console.warn('[loyalty] The reward terms could not be read from the LoyaltyLion card.');
      return;
    }
    if (!reward.description) return;
    const terms = document.createElement('div');
    terms.className = 'loyalty-reward-terms';
    terms.textContent = reward.description;
    box.insertBefore(terms, box.querySelector(':scope > .lion-redeem-reward-modal__free-product-variant-selector, :scope > .lion-redeem-reward-modal__button-container'));
  }

  // Avisa na consola quando o popup deixa de ter as peças que o CSS veste.
  function warnLoyaltyModalShape(wrapper, isReferral) {
    const required = isReferral
      ? ['.lion-referral-widget-modal', '.lion-referral-widget-modal__header', '.lion-referral-widget-main__share-link-container']
      : ['.lion-modal', '.lion-modal__header', '.lion-modal__title'];
    if (wrapper.querySelector('.lion-history-info-modal-content')) {
      required.push('.lion-history-info-modal-content__state-bubble', '.lion-reward-code');
    }
    const missing = required.filter(selector => !wrapper.querySelector(selector));
    if (!wrapper.querySelector('[role="dialog"]')) missing.push('[role="dialog"]');
    if (missing.length) {
      console.warn(`[loyalty] The LoyaltyLion popup markup has changed. These selectors no longer match, so the popup is partly unstyled: ${missing.join(', ')}`);
    }
  }

  function onLoyaltyModalOpened(wrapper, rule) {
    const isReferral = !!wrapper.querySelector('.lion-referral-widget-modal');
    if (!rule && isReferral) rule = describeLoyaltyRule(document.querySelector('.lion-rule-item--\\$referral'));

    if (rule && rule.id) wrapper.setAttribute('data-loyalty-rule', rule.id);
    if (rule && rule.rewardId) {
      wrapper.setAttribute('data-loyalty-reward', rule.rewardId);
      const art = loyaltyRewardArt(rule.rewardId);
      if (art) wrapper.style.setProperty('--loyalty-modal-art', art);
    }

    warnLoyaltyModalShape(wrapper, isReferral);

    if (isReferral) {
      // O título é o do card que abriu o popup, e a frase do link perde o "Or" do princípio.
      const header = wrapper.querySelector('.lion-referral-widget-modal__header');
      if (header && rule && rule.title) header.textContent = rule.title;
      const linkText = wrapper.querySelector('.lion-referral-widget-main__share-link-text');
      if (linkText) {
        const trimmed = linkText.textContent.trim().replace(/^or\s+/i, '');
        if (trimmed) linkText.textContent = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
      }
    }

    // "Redeem 50 points for this reward?" sem o ponto de interrogação, como no Figma.
    const summary = wrapper.querySelector('.lion-redeem-reward-modal__confirm-summary');
    if (summary) {
      const walker = document.createTreeWalker(summary, NodeFilter.SHOW_TEXT);
      let last = null;
      while (walker.nextNode()) if (walker.currentNode.nodeValue.trim()) last = walker.currentNode;
      if (last) last.nodeValue = last.nodeValue.replace(/\s*\?\s*$/, '');
    }

    if (rule && rule.rewardId) addLoyaltyRewardTerms(wrapper, rule.rewardId);
    formatLoyaltyThousands(wrapper);
  }

  function watchForLoyaltyModal(rule, timeout) {
    const found = () => {
      const wrapper = document.querySelector(loyaltyModalSelector);
      if (!wrapper) return false;
      onLoyaltyModalOpened(wrapper, rule);
      return true;
    };
    if (found()) return;
    const observer = new MutationObserver(() => { if (found()) stop(); });
    const timer = setTimeout(() => stop(), timeout);
    function stop() {
      observer.disconnect();
      clearTimeout(timer);
    }
    observer.observe(document.body, { childList: true, subtree: true });
  }

  let loyaltyCopiedTimer = null;

  document.addEventListener('click', event => {
    if (!document.querySelector('[data-loyalty]')) return;

    // "Copied" durante 3 s, no lugar do link copiado.
    const copy = event.target.closest('.lion-copy-to-clipboard-button');
    if (copy) {
      const container = copy.parentElement;
      container.setAttribute('data-loyalty-copied', '');
      clearTimeout(loyaltyCopiedTimer);
      loyaltyCopiedTimer = setTimeout(() => container.removeAttribute('data-loyalty-copied'), 3000);
      return;
    }

    const ruleCard = event.target.closest('.lion-rule-item');
    if (ruleCard) {
      watchForLoyaltyModal(describeLoyaltyRule(ruleCard), 4000);
      return;
    }

    const rewardCard = event.target.closest('.lion-reward-item, .lion-claimed-reward-item');
    if (rewardCard) watchForLoyaltyModal({ rewardId: rewardCard.getAttribute('data-reward-id') }, 4000);
  }, true);

  initLoyalty();

  // ?ll_act=refer abre o popup do "Refer a friend" ao carregar: dá-se mais tempo à LoyaltyLion.
  if (document.querySelector('[data-loyalty]') && /[?&]ll_act=refer(&|$)/.test(window.location.search)) {
    watchForLoyaltyModal(null, 15000);
  }

  // No editor, a section volta a ser desenhada e a LoyaltyLion não a enche sozinha.
  document.addEventListener('shopify:section:load', event => {
    if (!event.target.querySelector('[data-loyalty]')) return;
    initLoyalty();
    window.loyaltylion?.ui?.refresh?.();
  });

  document.addEventListener('shopify:section:unload', event => {
    if (loyaltyApi && event.target.querySelector('[data-loyalty]')) loyaltyApi.destroy();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-drawer"]) return;
  try {
    
  /* Uma só instância viva de cada vez. O bundle da Shopify corre uma vez, e no editor a section
     é substituída sem o reexecutar — daí o init nomeado e o destroy (ver CLAUDE.md). */
  const MENU_DRAWER_CLOSE_MS        = 500;
  const MENU_DRAWER_TAB_REDIRECT_MS = 500;
  const MENU_DRAWER_SEARCH_DEBOUNCE = 300;
  const MENU_DRAWER_SEARCH_MIN      = 2;
  let menuDrawerApi = null;

  /* O motor da pesquisa: a rota /search da Shopify, pedida pelo Section Rendering API. Devolve HTML
     já renderizado pelo Liquid (section search-results), com o product-card real — é isso que faz
     um redesenho do card propagar sozinho para os resultados. A rota é semântica: tolera erros de
     escrita ("jenas" devolve jeans) e percebe intenção. Afina-se na app Search & Discovery.
     O contador vem do Liquid num data-attribute, para não ter de contar nós. */
  function fetchMenuDrawerSearchResults(query, signal) {
    const url = '/search?q=' + encodeURIComponent(query) + '&type=product&section_id=search-results';
    return fetch(url, { signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        const root = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-search-results]');
        return { html: html, count: root ? parseInt(root.dataset.resultsCount, 10) || 0 : 0 };
      });
  }

  function initMenuDrawer() {
    if (menuDrawerApi) menuDrawerApi.destroy();

    const menuDrawerEl = document.getElementById('NavDrawer');
    if (!menuDrawerEl) return;

    let menuDrawerIsOpen   = false;
    let menuDrawerSourceEl = null;
    let menuDrawerInstant  = false;

    /* ── helpers ───────────────────────────────────────────── */
    function getMenuDrawerFocusable() {
      return Array.from(
        menuDrawerEl.querySelectorAll(
          'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      );
    }

    function trapMenuDrawerFocus(e) {
      const focusable = getMenuDrawerFocusable();
      if (!focusable.length) return;
      const first = focusable[0];
      const last  = focusable[focusable.length - 1];
      if (e.key === 'Tab') {
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
        }
      }
    }

    function handleMenuDrawerKeydown(e) {
      if (e.key === 'Escape') closeMenuDrawer();
    }

    /* ── open ──────────────────────────────────────────────── */
    /* Pela lupa (search = true), o drawer abre já em modo pesquisa, sem animação e com o campo
       focado: parece um popup de pesquisa. O foco tem de acontecer dentro do próprio clique, senão
       o iOS não abre o teclado — e só pega porque o drawer fica visível de imediato. */
    function openMenuDrawer(triggerEl, search) {
      if (menuDrawerIsOpen) return;
      menuDrawerIsOpen   = true;
      menuDrawerSourceEl = triggerEl || null;
      menuDrawerInstant  = Boolean(search);

      if (menuDrawerInstant) {
        menuDrawerEl.classList.add('menu-drawer--instant');
        document.documentElement.classList.add('js-drawer-instant');
        setMenuDrawerSearchState('suggestions');
      }

      menuDrawerEl.classList.add('menu-drawer--is-open');
      menuDrawerEl.offsetWidth; // force reflow
      document.documentElement.classList.add('js-drawer-open');
      document.documentElement.style.overflow = 'hidden';

      document.addEventListener('keydown', handleMenuDrawerKeydown);
      document.addEventListener('keydown', trapMenuDrawerFocus);

      if (menuDrawerInstant && menuDrawerSearchInput) {
        menuDrawerSearchInput.focus();
      } else {
        const focusable = getMenuDrawerFocusable();
        if (focusable.length) focusable[0].focus();
      }

      if (triggerEl) triggerEl.setAttribute('aria-expanded', 'true');
    }

    /* ── close ─────────────────────────────────────────────── */
    function closeMenuDrawer() {
      if (!menuDrawerIsOpen) return;
      menuDrawerIsOpen = false;

      resetMenuDrawerSearch();
      resetMenuDrawerTabs();
      menuDrawerEl.classList.remove('menu-drawer--is-open');
      document.documentElement.classList.remove('js-drawer-open');
      document.documentElement.style.overflow = '';

      document.removeEventListener('keydown', handleMenuDrawerKeydown);
      document.removeEventListener('keydown', trapMenuDrawerFocus);

      if (menuDrawerInstant) {
        /* Aberto pela lupa, fecha também sem animação e sem o fade do fundo. O reflow fixa o
           estado fechado ainda sem transição; só depois sai o modo instantâneo, para o hambúrguer
           voltar a deslizar. */
        menuDrawerEl.offsetWidth;
        menuDrawerEl.classList.remove('menu-drawer--instant');
        document.documentElement.classList.remove('js-drawer-instant');
        menuDrawerInstant = false;
      } else {
        document.documentElement.classList.add('js-drawer-closing');
        setTimeout(function () {
          document.documentElement.classList.remove('js-drawer-closing');
        }, MENU_DRAWER_CLOSE_MS);
      }

      if (menuDrawerSourceEl) {
        menuDrawerSourceEl.setAttribute('aria-expanded', 'false');
        menuDrawerSourceEl.focus();
        menuDrawerSourceEl = null;
      }
    }

    /* ── trigger buttons ───────────────────────────────────── */
    /* O hambúrguer abre o menu; a lupa abre-o já em modo pesquisa. */
    const menuDrawerTriggers = Array.from(document.querySelectorAll('.js-drawer-open-nav, .js-drawer-open-search'));

    function onMenuDrawerTriggerClick(e) {
      e.preventDefault();
      e.stopPropagation();
      openMenuDrawer(e.currentTarget, e.currentTarget.classList.contains('js-drawer-open-search'));
    }

    menuDrawerTriggers.forEach(function (btn) {
      btn.addEventListener('click', onMenuDrawerTriggerClick);
    });

    /* ── cliques dentro do drawer: fechar, categorias, tabs ── */
    function onMenuDrawerClick(e) {
      if (e.target.closest('.js-drawer-close')) {
        closeMenuDrawer();
        return;
      }

      /* Categoria com filhos — só uma aberta de cada vez: abrir uma fecha a que estiver aberta. */
      const toggle = e.target.closest('.menu-drawer__category-toggle');
      if (toggle) {
        const isOpen = toggle.getAttribute('aria-expanded') === 'true';
        menuDrawerEl.querySelectorAll('.menu-drawer__category-toggle').forEach(function (other) {
          other.setAttribute('aria-expanded', 'false');
        });
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        return;
      }

      /* Tag de pesquisa popular */
      const suggestion = e.target.closest('[data-search-suggestion]');
      if (suggestion) {
        menuDrawerApplySuggestion(suggestion.dataset.searchSuggestion);
        return;
      }

      /* Tabs WOMEN | MEN */
      const tab = e.target.closest('[data-menu-drawer-tab]');
      if (tab) selectMenuDrawerTab(tab.dataset.menuDrawerTab);
    }

    menuDrawerEl.addEventListener('click', onMenuDrawerClick);

    /* ── tabs ──────────────────────────────────────────────── */
    const menuDrawerTabs = menuDrawerEl.querySelector('[data-menu-drawer-tabs]');
    let menuDrawerTabTimer = null;

    /* O redirect espera pela animação da linha; clicar em WOMEN entretanto cancela-o, senão quem
       se enganasse ficava sem forma de voltar atrás. */
    function selectMenuDrawerTab(name) {
      if (!menuDrawerTabs) return;
      clearTimeout(menuDrawerTabTimer);
      menuDrawerTabTimer = null;

      const isMen = name === 'men';
      menuDrawerTabs.classList.toggle('menu-drawer__tabs--men', isMen);
      menuDrawerTabs.querySelectorAll('[data-menu-drawer-tab]').forEach(function (btn) {
        btn.setAttribute('aria-current', String(btn.dataset.menuDrawerTab === name));
      });

      if (!isMen) return;

      const url = menuDrawerTabs.dataset.menuDrawerMenUrl;
      if (!url) return;
      menuDrawerTabTimer = setTimeout(function () {
        window.location.href = url;
      }, MENU_DRAWER_TAB_REDIRECT_MS);
    }

    function resetMenuDrawerTabs() {
      clearTimeout(menuDrawerTabTimer);
      menuDrawerTabTimer = null;
      if (!menuDrawerTabs) return;
      menuDrawerTabs.classList.remove('menu-drawer__tabs--men');
      menuDrawerTabs.querySelectorAll('[data-menu-drawer-tab]').forEach(function (btn) {
        btn.setAttribute('aria-current', String(btn.dataset.menuDrawerTab === 'women'));
      });
    }

    /* ── search bar ───────────────────────────────────────── */
    const menuDrawerSearchInput   = menuDrawerEl.querySelector('[data-menu-drawer-search-input]');
    const menuDrawerSearchPanel   = menuDrawerEl.querySelector('[data-menu-drawer-search-panel]');
    const menuDrawerSearchResults = menuDrawerEl.querySelector('[data-menu-drawer-search-results]');
    let menuDrawerSearchTimer = null;
    let menuDrawerSearchFetch = null;

    /* Um só sítio decide o que se vê. Os três estados do Figma mapeiam para uma classe, e o CSS
       trata do resto — evita espalhar hidden/show por meia dúzia de sítios.
       'closed' | 'suggestions' (5029:8764) | 'results' (5029:8785) | 'empty' (5029:8810) */
    function setMenuDrawerSearchState(state) {
      if (!menuDrawerSearchPanel) return;
      menuDrawerSearchPanel.classList.remove(
        'menu-drawer__search-panel--suggestions',
        'menu-drawer__search-panel--results',
        'menu-drawer__search-panel--empty'
      );
      if (state === 'closed') {
        menuDrawerSearchPanel.setAttribute('hidden', '');
        menuDrawerEl.classList.remove('menu-drawer--searching');
        return;
      }
      menuDrawerSearchPanel.removeAttribute('hidden');
      menuDrawerEl.classList.add('menu-drawer--searching');
      /* Os recomendados só se pedem quando se vêem — no inicial e no sem resultados. */
      if ((state === 'suggestions' || state === 'empty') && window.theme && typeof window.theme.loadRecommendationsIn === 'function') {
        window.theme.loadRecommendationsIn(menuDrawerSearchPanel);
      }
      menuDrawerSearchPanel.classList.add('menu-drawer__search-panel--' + state);
    }

    function resetMenuDrawerSearch() {
      clearTimeout(menuDrawerSearchTimer);
      if (menuDrawerSearchFetch) { menuDrawerSearchFetch.abort(); menuDrawerSearchFetch = null; }
      if (menuDrawerSearchInput)   menuDrawerSearchInput.value = '';
      if (menuDrawerSearchResults) menuDrawerSearchResults.innerHTML = '';
      setMenuDrawerSearchState('closed');
    }

    function runMenuDrawerSearch() {
      if (!menuDrawerSearchInput || !menuDrawerSearchResults) return;
      const query = menuDrawerSearchInput.value.trim();

      /* Abaixo do mínimo volta ao estado inicial em vez de fechar: o painel já está aberto e
         fechá-lo a meio de apagar caracteres dava um salto. */
      if (query.length < MENU_DRAWER_SEARCH_MIN) {
        menuDrawerSearchResults.innerHTML = '';
        setMenuDrawerSearchState('suggestions');
        return;
      }

      if (menuDrawerSearchFetch) menuDrawerSearchFetch.abort();
      menuDrawerSearchFetch = new AbortController();

      fetchMenuDrawerSearchResults(query, menuDrawerSearchFetch.signal)
        .then(function (result) {
          menuDrawerSearchResults.innerHTML = result.html;
          setMenuDrawerSearchState(result.count > 0 ? 'results' : 'empty');
        })
        .catch(function (err) { if (err.name !== 'AbortError') console.error('[menu-drawer search]', err); })
        .finally(function () { menuDrawerSearchFetch = null; });
    }

    /* Uma tag preenche o campo e dispara a mesma pesquisa — é sugestão de pesquisa, não um
       atalho para uma colecção. */
    function menuDrawerApplySuggestion(term) {
      if (!menuDrawerSearchInput) return;
      menuDrawerSearchInput.value = term;
      clearTimeout(menuDrawerSearchTimer);
      runMenuDrawerSearch();
    }

    /* A pesquisa é a mesma em todos os ecrãs: em desktop acontece no drawer de 375, como no
       mobile (o modal de largura toda saiu). */
    function onMenuDrawerSearchFocus() {
      if (menuDrawerSearchInput.value.trim().length < MENU_DRAWER_SEARCH_MIN) {
        setMenuDrawerSearchState('suggestions');
      }
    }

    function onMenuDrawerSearchInput() {
      clearTimeout(menuDrawerSearchTimer);
      menuDrawerSearchTimer = setTimeout(runMenuDrawerSearch, MENU_DRAWER_SEARCH_DEBOUNCE);
    }

    if (menuDrawerSearchInput) {
      menuDrawerSearchInput.addEventListener('focus', onMenuDrawerSearchFocus);
      menuDrawerSearchInput.addEventListener('input', onMenuDrawerSearchInput);
    }

    /* ── click outside drawer ──────────────────────────────── */
    function onMenuDrawerOutsideClick(e) {
      if (!menuDrawerIsOpen) return;
      /* A barra do "+" abre-se dos cards do menu, mas vive fora dele: escolher um tamanho não o fecha. */
      if (!menuDrawerEl.contains(e.target) && !e.target.closest('.js-drawer-open-nav, .js-drawer-open-search, .quick-add-bar')) {
        closeMenuDrawer();
      }
    }

    document.addEventListener('click', onMenuDrawerOutsideClick);

    menuDrawerApi = {
      close: closeMenuDrawer,
      destroy() {
        closeMenuDrawer();
        clearTimeout(menuDrawerTabTimer);
        clearTimeout(menuDrawerSearchTimer);
        if (menuDrawerSearchFetch) menuDrawerSearchFetch.abort();
        /* Não basta contar com o DOM da section ser substituído: se um re-init apanhar o mesmo
           elemento, os listeners duplicam e cada clique passa a alternar duas vezes — ou seja,
           deixa de fazer nada. Removem-se todos, incluindo o do próprio drawer. */
        menuDrawerEl.removeEventListener('click', onMenuDrawerClick);
        if (menuDrawerSearchInput) {
          menuDrawerSearchInput.removeEventListener('focus', onMenuDrawerSearchFocus);
          menuDrawerSearchInput.removeEventListener('input', onMenuDrawerSearchInput);
        }
        menuDrawerTriggers.forEach(function (btn) {
          btn.removeEventListener('click', onMenuDrawerTriggerClick);
        });
        document.removeEventListener('click', onMenuDrawerOutsideClick);
        document.removeEventListener('keydown', handleMenuDrawerKeydown);
        document.removeEventListener('keydown', trapMenuDrawerFocus);
        menuDrawerApi = null;
      }
    };
  }

  initMenuDrawer();

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('#NavDrawer')) initMenuDrawer();
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (menuDrawerApi && e.target.querySelector && e.target.querySelector('#NavDrawer')) {
      menuDrawerApi.destroy();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  let pdpApi = null;

  function initPdp() {
    if (pdpApi) pdpApi.destroy();
    pdpApi = null;

    const pdp = document.querySelector('[data-pdp]');
    const pdpBar = document.querySelector('[data-pdp-bar]');
    if (!pdp || !pdpBar) return;

    /* Cada parte da página é um bloco que se pode esconder no theme editor. Sem os botões não há
       nada para ligar, e a página fica só de leitura; as outras partes são opcionais mais abaixo. */
    const pdpForm = pdp.querySelector('[data-pdp-form]');
    if (!pdpForm) return;
    const pdpVariantInput = pdpForm.querySelector('[name="id"]');
    const pdpAddButton = pdp.querySelector('[data-pdp-add]');
    const pdpPrice = pdp.querySelector('[data-pdp-price]');
    const pdpCompare = pdp.querySelector('[data-pdp-compare]');
    const pdpPreorder = pdp.querySelector('[data-pdp-preorder]');
    const pdpExpressCheckout = pdp.querySelector('[data-express-checkout]');
    const pdpShopPay = pdpExpressCheckout?.querySelector('.shop-pay-button');
    const pdpWishlist = pdp.querySelector('[data-pdp-wishlist]');
    const pdpGiftCard = pdp.querySelector('[data-pdp-gift-card]');
    const pdpGiftCardDate = pdpGiftCard?.querySelector('[data-gift-card-date]');
    const pdpNotify = pdp.querySelector('[data-notify-me]');
    const pdpNotifySku = pdpNotify?.querySelector('[name="sku"]');

    const pdpBarAdd = pdpBar.querySelector('[data-pdp-bar-add]');
    const pdpBarSize = pdpBar.querySelector('[data-pdp-bar-size]');

    /* Os três textos do botão existem duas vezes: no botão da página e no da barra. */
    const pdpAddLabels = document.querySelectorAll('[data-pdp-add-label]');
    const pdpPreorderLabels = document.querySelectorAll('[data-pdp-preorder-label]');
    const pdpNotifyLabels = document.querySelectorAll('[data-pdp-notify-label]');

    const pdpController = new AbortController();
    const signal = pdpController.signal;

    let pdpAddPassed = false;

    function selectedPdpSize() {
      return pdp.querySelector('[data-pdp-size][aria-pressed="true"]');
    }

    /* A barra vê-se a meio da página: depois de o ADD TO CART da página ter ficado para cima, e até
       o footer aparecer. */
    function renderPdpBar() {
      pdpBar.classList.toggle('bottom-bar--visible', pdpAddPassed && !window.theme?.footerVisible);
    }

    /* Copia para a página o que o servidor preparou para o tamanho escolhido. O dinheiro entra com
       innerHTML, porque o formato de algumas lojas traz <span class='money'>. */
    function renderPdpSize() {
      const size = selectedPdpSize();
      if (!size) return;
      const available = size.dataset.available === 'true';

      /* O change avisa o botão de pagamento rápido da Shopify, que lê a variação deste campo. */
      pdpVariantInput.value = size.dataset.variantId;
      pdpVariantInput.dispatchEvent(new Event('change', { bubbles: true }));

      if (pdpPrice) {
        pdpPrice.innerHTML = size.dataset.price;
        pdpPrice.classList.toggle('text-negative', Boolean(size.dataset.compare));
        pdpCompare.innerHTML = size.dataset.compare;
        pdpCompare.hidden = !size.dataset.compare;
      }

      if (pdpPreorder) {
        pdpPreorder.textContent = size.dataset.preorder;
        pdpPreorder.hidden = !size.dataset.preorder;
      }

      if (pdpExpressCheckout) pdpExpressCheckout.hidden = !available;
      if (pdpShopPay) pdpShopPay.href = size.dataset.shopPayUrl;

      if (pdpBarSize) pdpBarSize.textContent = size.textContent.trim();
      if (pdpNotifySku) pdpNotifySku.value = size.dataset.sku;

      /* O botão: NOTIFY ME no esgotado, PRE-ORDER no tamanho em pré-encomenda, ADD TO CART nos outros. */
      const preorder = available && Boolean(size.dataset.preorder);
      pdpAddLabels.forEach(label => { label.hidden = !available || preorder; });
      pdpPreorderLabels.forEach(label => { label.hidden = !preorder; });
      pdpNotifyLabels.forEach(label => { label.hidden = available; });
    }

    /* Os botões ficam presos enquanto o pedido corre, e assim um segundo toque não adiciona outra vez.
       O botão que submeteu entra no pedido: o do guia de tamanhos leva um name e um value, que marcam
       a linha do carrinho como adicionada por ele. */
    function addPdpToCart(submitter) {
      clearPdpGiftCardErrors();
      pdpAddButton.classList.add('btn--loading');
      pdpBarAdd.disabled = true;
      fetch(window.theme.routes.cartAdd, { method: 'POST', body: new FormData(pdpForm, submitter) })
        .then(response => response.json().then(data => {
          if (response.ok) {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
            return;
          }
          if (pdpGiftCard && data.errors) showPdpGiftCardErrors(data.errors);
          else throw new Error('HTTP ' + response.status);
        }))
        .catch(error => console.error('[pdp] add to cart failed', error))
        .finally(() => {
          pdpAddButton.classList.remove('btn--loading');
          pdpBarAdd.disabled = false;
        });
    }

    /* Gift cards: a Shopify recusa (422) os campos que não aceita, em errors ({ email: [...] }), com
       frases soltas ("is invalid"). Os campos ficam a vermelho e a linha de erro diz o texto do tema
       para cada um, ou o geral. O foco vai para o primeiro campo, como na validação do browser. */
    function showPdpGiftCardErrors(errors) {
      const pdpGiftCardError = pdpGiftCard.querySelector('[data-gift-card-error]');
      const messages = Object.keys(errors).map(key => {
        const field = pdpGiftCard.querySelector(`[data-gift-card-field="${key}"]`);
        if (field) field.setAttribute('aria-invalid', 'true');
        return field?.dataset.errorMessage || pdpGiftCardError.dataset.message;
      });
      pdpGiftCardError.querySelector('[data-gift-card-error-text]').textContent = [...new Set(messages)].join(' ');
      pdpGiftCard.querySelector('[aria-invalid="true"]')?.focus();
    }

    function clearPdpGiftCardErrors() {
      if (!pdpGiftCard) return;
      pdpGiftCard.querySelector('[data-gift-card-error-text]').textContent = '';
      pdpGiftCard.querySelectorAll('[aria-invalid]').forEach(field => field.removeAttribute('aria-invalid'));
    }

    /* O dia de envio vai de hoje a daqui a 90 dias, na data do cliente: é o que a Shopify aceita, e
       o servidor não sabe que dia é para o cliente. O "Delivery date" do Figma vê-se enquanto o
       campo está vazio. */
    function renderPdpGiftCardDate() {
      pdpGiftCardDate.toggleAttribute('data-empty', !pdpGiftCardDate.value);
    }

    function pdpIsoDay(date) {
      return [date.getFullYear(), String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0')].join('-');
    }

    /* O popup do NOTIFY ME (blocks/_pdp-notify-me), que trata do pedido. O foco vai para o email
       dentro do próprio toque, senão o iOS não abre o teclado. Com o bloco escondido no editor, não
       há popup e o botão não faz nada. */
    function openPdpNotify() {
      if (!pdpNotify || pdpNotify.open) return;
      pdpNotify.showModal();
      pdpNotify.querySelector('[type="email"]').focus();
    }

    function renderPdpWishlist() {
      pdpWishlist.setAttribute('aria-pressed', String(window.wishlistContains(pdp.dataset.productHandle)));
    }

    pdp.addEventListener('click', event => {
      const size = event.target.closest('[data-pdp-size]');
      if (size) {
        pdp.querySelectorAll('[data-pdp-size]').forEach(button =>
          button.setAttribute('aria-pressed', String(button === size)));
        renderPdpSize();
        return;
      }
      if (event.target.closest('[data-pdp-wishlist]')) window.updateWishlist(pdp.dataset.productHandle);
    }, { signal });

    /* O submit do formulário, pelo botão da página, pelo da barra ou pelo do guia de tamanhos. */
    pdpForm.addEventListener('submit', event => {
      event.preventDefault();
      const size = selectedPdpSize();
      if (size && size.dataset.available !== 'true') openPdpNotify();
      else addPdpToCart(event.submitter);
    }, { signal });

    if (pdpGiftCardDate) {
      const today = new Date();
      pdpGiftCardDate.min = pdpIsoDay(today);
      pdpGiftCardDate.max = pdpIsoDay(new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90));
      renderPdpGiftCardDate();
      pdpGiftCardDate.addEventListener('input', renderPdpGiftCardDate, { signal });
    }

    if (pdpWishlist) {
      if (window.theme.wishlistReady) renderPdpWishlist();
      document.addEventListener('shopify-wishlist:ready', renderPdpWishlist, { signal });
      document.addEventListener('shopify-wishlist:updated', renderPdpWishlist, { signal });
    }

    /* O footer avisa quando entra e sai do ecrã (sections/footer). Com ele à vista a barra sai. */
    document.addEventListener('footer:visibility', renderPdpBar, { signal });

    /* "Ficou para cima": fora do ecrã, pelo lado de cima. No topo da página, com o botão ainda por
       chegar, a barra fica escondida. A margem de baixo estende a zona observada até ao fim da
       página, para o estado só mudar quando o botão cruza o topo do ecrã: sem ela, um salto de
       scroll que passe o botão de cima para baixo do ecrã (voltar ao topo, o browser a repor a
       posição) não era avisado. */
    const pdpAddObserver = new IntersectionObserver(([entry]) => {
      pdpAddPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      renderPdpBar();
    }, { rootMargin: '0px 0px 100000px 0px' });
    pdpAddObserver.observe(pdpAddButton);

    pdpApi = {
      destroy() {
        pdpController.abort();
        pdpAddObserver.disconnect();
      }
    };
  }

  initPdp();

  /* O editor troca o HTML da section sem voltar a correr isto. */
  document.addEventListener('shopify:section:load', event => {
    if (event.target.querySelector('[data-pdp]')) initPdp();
  });

  document.addEventListener('shopify:section:unload', event => {
    if (pdpApi && event.target.querySelector('[data-pdp]')) {
      pdpApi.destroy();
      pdpApi = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["track-order"] && !Shopify.designMode) return;
  try {
    
  const trackOrderVisibleUpdates = 3;

  // A plataforma escreve "2026-09-14 08:19:00". Mostra-se a mesma hora, como no Figma:
  // "14 Sept 2026, 08:19" (as maiúsculas são da utility).
  function formatTrackOrderDate(value) {
    const date = new Date(String(value || '').replace(' ', 'T'));
    if (isNaN(date)) return value || '';
    const month = date.toLocaleString('en-GB', { month: 'short' });
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${date.getDate()} ${month} ${date.getFullYear()}, ${hours}:${minutes}`;
  }

  function getTrackOrderUpdateTime(update) {
    const time = new Date(String(update.when || update.date || '').replace(' ', 'T')).getTime();
    return isNaN(time) ? 0 : time;
  }

  // A lógica do tema antigo: um evento entregue manda sobre um em trânsito. Sem eventos, o status 0
  // é "Order placed". A plataforma escreve "In transit" e "Delivered": conta a palavra, não o texto
  // inteiro.
  function getTrackOrderState(data, updates) {
    const labels = updates.map(update => String(update.label || '').toLowerCase());
    if (labels.some(label => /\bdelivered\b/.test(label))) return 'delivered';
    if (labels.some(label => /\btransit\b/.test(label))) return 'transit';
    if (!updates.length && data.status === 0) return 'placed';
    return 'processing';
  }

  function showTrackOrderResult(result, data) {
    const updates = (Array.isArray(data.events) ? [...data.events] : [])
      .sort((a, b) => getTrackOrderUpdateTime(b) - getTrackOrderUpdateTime(a));
    const state = getTrackOrderState(data, updates);
    const list = result.querySelector('[data-track-order-updates]');
    const template = result.querySelector('[data-track-order-update-template]');
    const labelTitles = { transit: list.dataset.labelTransit, delivered: list.dataset.labelDelivered };
    const currentStep = { transit: 1, delivered: 2 }[state] || 0;

    result.dataset.state = state;
    delete result.dataset.trackOrderPreview;
    result.querySelector('[data-track-order-carrier]').textContent = data.carrier || '';
    result.querySelectorAll('[data-track-order-step]').forEach((step, index) => {
      if (index === currentStep) step.setAttribute('aria-current', 'step');
      else step.removeAttribute('aria-current');
    });

    list.querySelectorAll('[data-track-order-update]').forEach(row => row.remove());
    list.querySelectorAll('[data-track-order-waiting]').forEach(row => {
      row.hidden = updates.length > 0 || row.dataset.trackOrderWaiting !== state;
    });

    updates.forEach((update, index) => {
      const row = template.content.firstElementChild.cloneNode(true);
      const date = row.querySelector('[data-track-order-date]');
      const description = row.querySelector('[data-track-order-description]');
      const label = String(update.label || '').toLowerCase();

      if (update.when || update.date) date.textContent = formatTrackOrderDate(update.when || update.date);
      else date.remove();
      row.querySelector('[data-track-order-update-title]').textContent =
        update.title || labelTitles[label] || update.label || '';
      if (update.desc || update.description) description.textContent = update.desc || update.description;
      else description.remove();

      row.hidden = index >= trackOrderVisibleUpdates;
      list.append(row);
    });

    result.querySelector('[data-track-order-more]').hidden = updates.length <= trackOrderVisibleUpdates;
    result.hidden = false;
  }

  async function trackOrder(form) {
    const result = form.closest('[data-track-order]')?.querySelector('[data-track-order-result]');
    const button = form.querySelector('[type="submit"]');
    const error = form.querySelector('[data-track-order-error]');
    const errorText = error.querySelector('[data-track-order-error-text]');
    const fields = [form.elements.email, form.elements.order];
    const url = new URL(form.dataset.trackOrderUrl);
    url.searchParams.set('order', form.elements.order.value.trim());
    url.searchParams.set('email', form.elements.email.value.trim());

    errorText.textContent = '';
    fields.forEach(field => field.removeAttribute('aria-invalid'));
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      const response = await fetch(url);
      // A encomenda que a plataforma não encontra (número ou email errados) vem com 404: os dois
      // campos ficam a vermelho.
      if (response.status === 404) {
        if (result) result.hidden = true;
        fields.forEach(field => field.setAttribute('aria-invalid', 'true'));
        errorText.textContent = error.dataset.messageNotFound;
        return;
      }
      if (!response.ok) throw new Error(`Tracking request failed: ${response.status}`);
      const data = await response.json();
      if (!data || typeof data !== 'object') throw new Error('Invalid tracking response');
      if (result) {
        showTrackOrderResult(result, data);
        result.querySelector('[data-track-order-title]').focus();
      }
    } catch (trackingError) {
      if (result) result.hidden = true;
      errorText.textContent = error.dataset.message;
    } finally {
      form.removeAttribute('aria-busy');
      button.disabled = false;
    }
  }

  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-track-order-form]');
    if (!form) return;
    event.preventDefault();
    trackOrder(form);
  });

  document.addEventListener('click', event => {
    const more = event.target.closest('[data-track-order-more]');
    if (!more) return;
    const hiddenRows = [...more.closest('[data-track-order-result]').querySelectorAll('[data-track-order-update][hidden]')];
    hiddenRows.forEach(row => { row.hidden = false; });
    more.hidden = true;
    // O botão desaparece: o foco passa para a primeira actualização que apareceu, para não se perder.
    const firstTitle = hiddenRows[0]?.querySelector('[data-track-order-update-title]');
    if (firstTitle) {
      firstTitle.tabIndex = -1;
      firstTitle.focus();
    }
  });

  // No editor, o resultado aparece enquanto o bloco está seleccionado, com o exemplo "Order placed" e
  // os dois textos de espera, para se ver o que se edita. Ao largar o bloco, volta a esconder-se.
  document.addEventListener('shopify:block:select', event => {
    const result = event.target;
    if (!result.matches?.('[data-track-order-result]') || !result.hidden) return;
    result.dataset.trackOrderPreview = '';
    result.querySelectorAll('[data-track-order-waiting]').forEach(row => { row.hidden = false; });
    result.hidden = false;
  });

  document.addEventListener('shopify:block:deselect', event => {
    const result = event.target;
    if (!result.matches?.('[data-track-order-result][data-track-order-preview]')) return;
    delete result.dataset.trackOrderPreview;
    result.querySelectorAll('[data-track-order-waiting]').forEach(row => { row.hidden = true; });
    result.hidden = true;
  });

  // O link da página da encomenda na conta (?order=…&email=…) preenche o formulário e pesquisa sozinho.
  const trackOrderParams = new URLSearchParams(window.location.search);
  const trackOrderForm = document.querySelector('[data-track-order-form]');
  if (trackOrderForm && trackOrderParams.get('order') && trackOrderParams.get('email')) {
    trackOrderForm.elements.order.value = trackOrderParams.get('order');
    trackOrderForm.elements.email.value = trackOrderParams.get('email');
    trackOrderForm.requestSubmit();
  }

  } catch(e) { console.error(e); }
})();
})();
